import React from 'react';
import {Helmet} from 'react-helmet';

import {canonicalUrl, meta, title} from 'lib/head';
import {safeJsonLdStringify} from 'client/StructuredData/safeJsonLdStringify';

export interface PageMetadataProps {
  title?: string | string[];
  metaDescription?: string;
  canonicalUrl?: string;
  robots?: string;
  structuredData?: Record<string, unknown>;
}

/** Renders resolved page metadata without choosing or rewriting its copy. */
export function PageMetadata(props: PageMetadataProps) {
  return (
    <>
      <Helmet>
        {title(props.title)}
        {meta.description(props.metaDescription)}
        {canonicalUrl(props.canonicalUrl)}
        {props.robots && <meta name='robots' content={props.robots} />}
      </Helmet>
      {props.structuredData && (
        <script
          type='application/ld+json'
          dangerouslySetInnerHTML={{__html: safeJsonLdStringify(props.structuredData)}}
        />
      )}
    </>
  );
}
